const initialProps = {
  detalleTicket: [],
};

export default function (state = initialProps, action) {
  switch (action.type) {
    case "UPDATE_DETALLE_TICKET":
      return {
        ...state,
        detalleTicket: action.payload,
      };
    default:
      return state;
  }
}
